import React, { useEffect, useState } from 'react'
import { Button, HStack, TabItem, Tabs, Typography, VStack, XelaColor } from '@/XelaReact'
import { Checkbox, LoadingOverlay, SelectItem } from '@mantine/core'
import { useDispatch } from 'react-redux'
import { router, useForm } from '@inertiajs/react'
import { updateShowAddQuickLeadModal } from '@/Store/leadSlice'
import XSelect from '@/Mantine/XSelect'
import XTextInput from '@/Mantine/XTextInput'
import useLocation from '@/Hooks/useLocation'
import useFlash from '@/Hooks/useFlash'
import useMeta from '@/Hooks/useMeta'
import axios from 'axios'
import useAuth from '@/Hooks/useAuth'
import XPhoneInput from '@/Mantine/XPhoneInput'
import Divider from '@/XelaReact/Divider/Divider'
import XDatePicker from '@/Mantine/XDatePicker'
import XNumberInput from '@/Mantine/XNumberInput'
import moment from 'moment/moment'
import { XTextarea } from '@/Mantine/XTextarea'
import { EntitySectionData } from '@/Types/EntitySubTypes'
import { getOrderOfFieldByLabel, getSelectedOfFieldByLabel } from '@/helpers'
import COUNTRY_FORMATS from '@/Constants/CountryFormats'
import XNationalInput from '@/Mantine/XNationalInput'
import XSelectWithRole from '@/Mantine/XSelectWithRole'

const CreateQuickStudyLead = () => {
  const auth = useAuth()
  const meta = useMeta()
  const flash = useFlash()
  const dispatch = useDispatch()
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [countries, setCountries] = useState<SelectItem[]>([])
  const [secondCountries, setSecondCountries] = useState<SelectItem[]>([])
  const [thirdCountries, setThirdCountries] = useState<SelectItem[]>([])
  const [educationTab, setEducationTab] = React.useState('')
  const [languageTab, setLanguageTab] = React.useState('')
  const [familyTab, setFamilyTab] = React.useState('')
  const [fieldsData] = useState<EntitySectionData>(meta.entityForms['study_lead_form'])
  const [formCategory, setFormCategory] = useState<Record<string, boolean>>({})
  const { data, setData, post, errors, reset } = useForm<{
    lead_source: string
    sub_lead_source: string
    given_name: string
    surname: string
    phone: string
    email: string
    marital_status: string
    permanent_address: string
    country: string
    permanent_state: string
    permanent_city: string
    permanent_pincode: string
    country_code: string
    country_calling_code: string
    preferred_country: string
    preferred_country_code: string
    second_preferred_country: string
    second_preferred_country_code: string
    third_preferred_country: string
    third_preferred_country_code: string
    other_country: string
    visa_type: string
    branch_id: string
    counsellor_id: string
    middle_name: string
    date_of_birth: string
    gender: string
    martial_status: string
    marriage_date: string
    estimated_budget: number | '' | null
    alternate_phone: string
    alternate_country: string
    alternate_country_code: string
    alternate_country_calling_code: string
    current_address: string
    current_city: string
    current_pincode: string
    current_state: string
    current_country: string
    current_country_code: string
    preferred_course_type: string
    preferred_course_name: string
    tenth_school_name: string
    tenth_year: number | ''
    tenth_board: string
    tenth_percentage: number | ''
    tenth_medium_of_instruction: string
    tenth_result_date: string
    twelfth_school_name: string
    twelfth_year: number | ''
    twelfth_board: string
    twelfth_percentage: number | ''
    twelfth_stream: string
    twelfth_english_marks: string
    twelfth_medium_of_instruction: string
    twelfth_result_date: string
    bachelor_one_year: number | ''
    bachelor_one_college: string
    bachelor_one_course: string
    bachelor_one_percentage: number | ''
    bachelor_one_reappears: number | ''
    bachelor_one_duration: string
    bachelor_one_result_date: string
    bachelor_one_medium_of_instruction: string
    master_one_year: number | ''
    master_one_college: string
    master_one_course: string
    master_one_percentage: number | ''
    master_one_reappears: number | ''
    master_one_duration: string
    master_one_result_date: string
    master_one_medium_of_instruction: string
    diploma_one_year: number | ''
    diploma_one_college: string
    diploma_one_course: string
    diploma_one_percentage: number | ''
    diploma_one_reappears: number | ''
    diploma_one_duration: string
    diploma_one_level: string
    diploma_one_result_date: string
    diploma_one_medium_of_instruction: string
    other_educations: string
    language_ielts_overall_score: number | null | ''
    language_ielts_listening_score: number | null | ''
    language_ielts_reading_score: number | null | ''
    language_ielts_writing_score: number | null | ''
    language_ielts_speaking_score: number | null | ''
    language_ielts_test_date: string | null
    language_toefl_overall_score: number | null | ''
    language_toefl_reading_score: number | null | ''
    language_toefl_listening_score: number | null | ''
    language_toefl_speaking_score: number | null | ''
    language_toefl_writing_score: number | null | ''
    language_toefl_test_date: string | null
    language_pte_overall_score: number | null | ''
    language_pte_listening_score: number | null | ''
    language_pte_reading_score: number | null | ''
    language_pte_speaking_score: number | null | ''
    language_pte_writing_score: number | null | ''
    language_pte_test_date: string | null
    aptitude_gre_overall_score: number | null | ''
    aptitude_gre_verbal_score: number | null | ''
    aptitude_gre_quantitative_score: number | null | ''
    aptitude_gre_analytical_score: number | null | ''
    aptitude_gre_test_date: string | null
    aptitude_gmat_overall_score: number | null | ''
    aptitude_gmat_verbal_score: number | null | ''
    aptitude_gmat_quantitative_score: number | null | ''
    aptitude_gmat_test_date: string | null
    aptitude_sat_overall_score: number | null | ''
    aptitude_sat_english_score: number | null | ''
    aptitude_sat_math_score: number | null | ''
    aptitude_sat_test_date: string | null
    language_duolingo_test_date: string | null
    language_duolingo_overall_score: number | null | ''
    language_duolingo_listening_score: number | null | ''
    language_duolingo_reading_score: number | null | ''
    language_duolingo_writing_score: number | null | ''
    language_duolingo_speaking_score: number | null | ''
    language_duolingo_login_id: string | null
    language_duolingo_login_password: string | null
    passport_number: string
    passport_nationality: string
    passport_issue_date: string
    passport_expiry_date: string
    passport_issue_place: string
    passport_birth_place: string
    previous_passport_number: string
    is_visa_rejected_in_past: boolean
    visa_rejection_one_country: string
    visa_rejection_one_year: number | ''
    visa_rejection_one_reason: string
    work_experience_one_company_name: string
    work_experience_one_job_title: string
    work_experience_one_is_still_working: boolean
    work_experience_one_start_date: string
    work_experience_one_end_date: string
    father_name: string
    father_first_name: string
    father_last_name: string
    father_phone: string
    father_country_calling_code: string
    father_country_code: string
    father_country: string
    father_email: string
    father_dob: string
    father_occupation: string
    father_address: string
    father_aadhaar_uid: string
    mother_name: string
    mother_first_name: string
    mother_last_name: string
    mother_phone: string
    mother_country_calling_code: string
    mother_country_code: string
    mother_country: string
    mother_email: string
    mother_dob: string
    mother_occupation: string
    mother_address: string
    mother_aadhaar_uid: string
    national_id: string
    tag: string
    accommodation: string
    travel_history: string
  }>({
    lead_source: 'Walk In',
    sub_lead_source: '',
    middle_name: '',
    given_name: '',
    surname: '',
    phone: '',
    email: '',
    date_of_birth: '',
    marital_status: '',
    alternate_phone: '',
    permanent_address: '',
    country: 'India',
    country_code: 'IN',
    country_calling_code: '+91',
    permanent_state: '',
    permanent_city: '',
    permanent_pincode: '',
    preferred_country: '',
    preferred_country_code: '',
    second_preferred_country: '',
    second_preferred_country_code: '',
    third_preferred_country: '',
    third_preferred_country_code: '',
    other_country: '',
    preferred_course_type: '',
    preferred_course_name: '',
    visa_type: 'Single',
    branch_id: auth.branch.id.toString(),
    counsellor_id: '',
    gender: 'Male',
    martial_status: 'Not Married',
    marriage_date: '',
    estimated_budget: '',
    alternate_country: 'India',
    alternate_country_code: 'IN',
    alternate_country_calling_code: '+91',
    current_address: '',
    current_city: '',
    current_pincode: '',
    current_state: '',
    current_country: 'India',
    current_country_code: 'IN',
    tenth_school_name: '',
    tenth_year: '',
    tenth_board: '',
    tenth_percentage: '',
    tenth_medium_of_instruction: '',
    tenth_result_date: '',
    twelfth_school_name: '',
    twelfth_year: '',
    twelfth_board: '',
    twelfth_percentage: '',
    twelfth_stream: '',
    twelfth_english_marks: '',
    twelfth_medium_of_instruction: '',
    twelfth_result_date: '',
    bachelor_one_year: '',
    bachelor_one_college: '',
    bachelor_one_course: '',
    bachelor_one_percentage: '',
    bachelor_one_reappears: 0,
    bachelor_one_duration: '',
    bachelor_one_result_date: '',
    bachelor_one_medium_of_instruction: '',
    master_one_year: '',
    master_one_college: '',
    master_one_course: '',
    master_one_percentage: '',
    master_one_reappears: 0,
    master_one_duration: '',
    master_one_result_date: '',
    master_one_medium_of_instruction: '',
    diploma_one_year: '',
    diploma_one_college: '',
    diploma_one_course: '',
    diploma_one_percentage: '',
    diploma_one_reappears: 0,
    diploma_one_duration: '',
    diploma_one_level: '',
    diploma_one_result_date: '',
    diploma_one_medium_of_instruction: '',
    other_educations: '',
    language_ielts_overall_score: null,
    language_ielts_listening_score: null,
    language_ielts_reading_score: null,
    language_ielts_writing_score: null,
    language_ielts_speaking_score: null,
    language_ielts_test_date: '',
    language_toefl_overall_score: null,
    language_toefl_reading_score: null,
    language_toefl_listening_score: null,
    language_toefl_speaking_score: null,
    language_toefl_writing_score: null,
    language_toefl_test_date: '',
    language_pte_overall_score: null,
    language_pte_listening_score: null,
    language_pte_reading_score: null,
    language_pte_speaking_score: null,
    language_pte_writing_score: null,
    language_pte_test_date: '',
    aptitude_gre_overall_score: null,
    aptitude_gre_verbal_score: null,
    aptitude_gre_quantitative_score: null,
    aptitude_gre_analytical_score: null,
    aptitude_gre_test_date: '',
    aptitude_gmat_overall_score: null,
    aptitude_gmat_verbal_score: null,
    aptitude_gmat_quantitative_score: null,
    aptitude_gmat_test_date: '',
    aptitude_sat_overall_score: null,
    aptitude_sat_english_score: null,
    aptitude_sat_math_score: null,
    aptitude_sat_test_date: '',
    language_duolingo_test_date: '',
    language_duolingo_overall_score: null,
    language_duolingo_listening_score: null,
    language_duolingo_reading_score: null,
    language_duolingo_writing_score: null,
    language_duolingo_speaking_score: null,
    language_duolingo_login_id: '',
    language_duolingo_login_password: '',
    passport_number: '',
    passport_nationality: '',
    passport_issue_date: '',
    passport_expiry_date: '',
    passport_issue_place: '',
    passport_birth_place: '',
    previous_passport_number: '',
    is_visa_rejected_in_past: false,
    visa_rejection_one_country: '',
    visa_rejection_one_year: '',
    visa_rejection_one_reason: '',
    work_experience_one_company_name: '',
    work_experience_one_job_title: '',
    work_experience_one_is_still_working: false,
    work_experience_one_start_date: '',
    work_experience_one_end_date: '',
    father_name: '',
    father_first_name: '',
    father_last_name: '',
    father_phone: '',
    father_country_calling_code: '+91',
    father_country_code: 'IN',
    father_country: 'India',
    father_email: '',
    father_dob: '',
    father_occupation: '',
    father_address: '',
    father_aadhaar_uid: '',
    mother_name: '',
    mother_first_name: '',
    mother_last_name: '',
    mother_phone: '',
    mother_country_calling_code: '+91',
    mother_country_code: 'IN',
    mother_country: 'India',
    mother_email: '',
    mother_dob: '',
    mother_occupation: '',
    mother_address: '',
    mother_aadhaar_uid: '',
    national_id: '',
    tag: '',
    accommodation: '',
    travel_history: '',
  })

  useEffect(() => {
    if (flash.action === 'lead:created') {
      const payload = flash.payload as {
        lead_id: number | string
      } | null

      if (payload) {
        const counsellorId = data.counsellor_id
        dispatch(updateShowAddQuickLeadModal(false))
        reset()

        if (
          auth.role.permissions.includes('lead_module_all_leads') ||
          (auth.role.permissions.includes('lead_module_manage_lead') && counsellorId === auth.user.id.toString())
        ) {
          router.visit(route('leads.id', { id: payload.lead_id }))
        }
      }
    }
  }, [flash.timestamp])

  useEffect(() => {
    if (location.country_code) {
      setData((prevData) => ({
        ...prevData,
        country: location.country_name,
        country_code: location.country_code,
        country_calling_code: location.country_calling_code,
      }))
    }
  }, [location])

  useEffect(() => {
    axios
      .post<Record<string, string>>('/select/meta-options', {
        entity_name: 'countries',
        column_name: 'country',
        with_key: true,
      })
      .then((response) => {
        const countryList = Object.keys(response.data).map((key) => {
          return {
            value: key,
            label: response.data[key],
          }
        })

        setCountries(countryList)
        setSecondCountries(countryList)
        setThirdCountries(countryList)
      })
      .catch((error) => {
        console.error('Error fetching countries:', error)
      })
  }, [])

  const [counsellorData, setCounsellorData] = useState(
    meta.branchesUsers[auth.branch.id].users.map((counsellor) => {
      let isCounsellorEnabled = false

      if (
        auth.role.permissions.includes('lead_module_manage_lead') ||
        auth.role.permissions.includes('lead_module_branch_leads') ||
        auth.role.permissions.includes('lead_module_all_leads')
      ) {
        isCounsellorEnabled = true
      }

      return {
        value: counsellor.id.toString(),
        label: counsellor.name,
        group: counsellor.branch.branch_name,
        role: counsellor.role.role_name,
        disabled: !isCounsellorEnabled,
      }
    })
  )

  useEffect(() => {
    setData((prevData) => ({
      ...prevData,
      counsellor_id: '',
    }))

    if (data.branch_id) {
      setCounsellorData(
        meta.branchesUsers[data.branch_id].users.map((counsellor) => {
          let isCounsellorEnabled = false

          if (
            auth.role.permissions.includes('lead_module_manage_lead') ||
            auth.role.permissions.includes('lead_module_branch_leads') ||
            auth.role.permissions.includes('lead_module_all_leads')
          ) {
            isCounsellorEnabled = true
          }

          return {
            value: counsellor.id.toString(),
            label: counsellor.name,
            group: counsellor.branch.branch_name,
            role: counsellor.role.role_name,
            disabled: !isCounsellorEnabled,
          }
        })
      )
    }
  }, [data.branch_id])

  /*useEffect(() => {
    const branchLeadPermission = auth.role.permissions.includes('lead_module_branch_leads')
    const allPermission = auth.role.permissions.includes('lead_module_all_leads')
    const leadPermission = auth.role.permissions.includes('lead_module_manage_lead')

    if (data.branch_id) {
      const users = meta.branchesUsers[data.branch_id]?.users || []

      const filterAndMapCounsellors = (users: User[]) =>
        users.map((counsellor) => {
          const isCounsellorEnabled = [
            'lead_module_manage_lead',
            'lead_module_branch_leads',
            'lead_module_all_leads',
          ].some((permission) => counsellor.role.permissions.includes(permission))

          return {
            value: counsellor.id.toString(),
            label: counsellor.name,
            group: counsellor.branch.branch_name,
            role: counsellor.role.role_name,
            disabled: !isCounsellorEnabled,
          }
        })

      if (allPermission) {
        setCounsellorData(filterAndMapCounsellors(users))
      } else if (branchLeadPermission && data.branch_id === auth.user.branch_id.toString()) {
        const branchUsers = users.filter((user) => user.branch.branch_name === auth.user.branch.branch_name)
        setCounsellorData(filterAndMapCounsellors(branchUsers))
      } else if (leadPermission) {
        const filteredCounsellors = meta.counsellors.filter((counsellor) => counsellor.id === auth.user.id)
        setCounsellorData(filterAndMapCounsellors(filteredCounsellors))
      } else {
        const filteredCounsellors = meta.counsellors.filter((counsellor) => counsellor.id === auth.user.id)
        setCounsellorData(filterAndMapCounsellors(filteredCounsellors))
      }
    }
  }, [data.branch_id])*/

  useEffect(() => {
    if (fieldsData) {
      const categoryData: Record<string, boolean> = {}
      Object.entries(fieldsData).forEach(([category, formItems]) => {
        categoryData[category] = formItems.some((formItem) => formItem.selected)
      })
      setFormCategory(categoryData)
    }
  }, [fieldsData])

  const languageTabArrangement = [
    {
      label: 'IELTS',
      value: 'IELTS',
      fieldName: 'ielts_details',
      order: getOrderOfFieldByLabel(fieldsData, 'language_aptitude_test_details', 'ielts_details'),
    },
    {
      label: 'TOEFL',
      value: 'TOEFL',
      fieldName: 'toefl_details',
      order: getOrderOfFieldByLabel(fieldsData, 'language_aptitude_test_details', 'toefl_details'),
    },
    {
      label: 'PTE',
      value: 'PTE',
      fieldName: 'pte_details',
      order: getOrderOfFieldByLabel(fieldsData, 'language_aptitude_test_details', 'pte_details'),
    },
    {
      label: 'GRE',
      value: 'GRE',
      fieldName: 'gre_details',
      order: getOrderOfFieldByLabel(fieldsData, 'language_aptitude_test_details', 'gre_details'),
    },
    {
      label: 'GMAT',
      value: 'GMAT',
      fieldName: 'gmat_details',
      order: getOrderOfFieldByLabel(fieldsData, 'language_aptitude_test_details', 'gmat_details'),
    },
    {
      label: 'SAT',
      value: 'SAT',
      fieldName: 'sat_details',
      order: getOrderOfFieldByLabel(fieldsData, 'language_aptitude_test_details', 'sat_details'),
    },
    {
      label: 'DUOLINGO',
      value: 'DUOLINGO',
      fieldName: 'duolingo_details',
      order: getOrderOfFieldByLabel(fieldsData, 'language_aptitude_test_details', 'duolingo_details'),
    },
  ]

  languageTabArrangement.sort((a, b) => a.order - b.order)

  useEffect(() => {
    if (languageTabArrangement.length > 0) {
      const availableTabs = languageTabArrangement.filter((tab) =>
        getSelectedOfFieldByLabel(fieldsData, 'language_aptitude_test_details', tab.fieldName)
      )
      if (availableTabs.length > 0) {
        setLanguageTab(availableTabs[0].label)
      }
    }
  }, [fieldsData])

  const educationTabArrangement = [
    {
      label: 'Tenth',
      value: 'Tenth(SSC)',
      fieldName: 'tenth_details',
      order: getOrderOfFieldByLabel(fieldsData, 'education_details', 'tenth_details'),
    },
    {
      label: 'Twelfth',
      value: 'Twelfth(HSC)',
      fieldName: 'twelfth_details',
      order: getOrderOfFieldByLabel(fieldsData, 'education_details', 'twelfth_details'),
    },
    {
      label: 'Bachelors',
      value: 'Bachelors',
      fieldName: 'bachelors_details',
      order: getOrderOfFieldByLabel(fieldsData, 'education_details', 'bachelors_details'),
    },
    {
      label: 'Masters',
      value: 'Masters',
      fieldName: 'masters_details',
      order: getOrderOfFieldByLabel(fieldsData, 'education_details', 'masters_details'),
    },
    {
      label: 'Diplomas',
      value: 'Diplomas',
      fieldName: 'diploma_details',
      order: getOrderOfFieldByLabel(fieldsData, 'education_details', 'diploma_details'),
    },
    {
      label: 'Others',
      value: 'Others',
      fieldName: 'other_educations',
      order: getOrderOfFieldByLabel(fieldsData, 'education_details', 'other_educations'),
    },
  ]

  educationTabArrangement.sort((a, b) => a.order - b.order)

  useEffect(() => {
    if (educationTabArrangement.length > 0) {
      const availableTabs = educationTabArrangement.filter((tab) =>
        getSelectedOfFieldByLabel(fieldsData, 'education_details', tab.fieldName)
      )
      if (availableTabs.length > 0) {
        setEducationTab(availableTabs[0].label)
      }
    }
  }, [fieldsData])

  const familyTabArrangement = [
    {
      label: 'Father',
      value: 'Father',
      fieldName: 'father_details',
      order: getOrderOfFieldByLabel(fieldsData, 'family_details', 'father_details'),
    },
    {
      label: 'Mother',
      value: 'Mother',
      fieldName: 'mother_details',
      order: getOrderOfFieldByLabel(fieldsData, 'family_details', 'mother_details'),
    },
  ]

  familyTabArrangement.sort((a, b) => a.order - b.order)

  useEffect(() => {
    if (familyTabArrangement.length > 0) {
      const availableTabs = familyTabArrangement.filter((tab) =>
        getSelectedOfFieldByLabel(fieldsData, 'family_details', tab.fieldName)
      )
      if (availableTabs.length > 0) {
        setFamilyTab(availableTabs[0].label)
      }
    }
  }, [fieldsData])

  return (
    <VStack
      spacing="12px"
      style={{
        height: '100%',
        position: 'relative',
      }}
    >
      <LoadingOverlay visible={loading} overlayBlur={2} loaderProps={{ color: 'blueX' }} />
      <VStack
        className={'pr-2 overflow-y-auto'}
        spacing={'32px'}
        style={{
          flex: '1 1 0',
          height: 0,
        }}
      >
        <VStack spacing={'12px'}>
          <Typography color={XelaColor.Blue3} variant={'body-small-bold'}>
            Personal Details
          </Typography>

          <div className="grid grid-cols-2 w-full gap-4 items-start p-[1px]">
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'given_name') && (
              <HStack
                style={{
                  order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'given_name'),
                }}
              >
                <XTextInput
                  data-autofocus
                  required
                  label={'Given Name'}
                  error={errors.given_name}
                  value={data.given_name}
                  onChange={(event) => {
                    setData((prevData) => ({
                      ...prevData,
                      given_name: event.target.value,
                    }))
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'middle_name') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'middle_name') }}>
                <XTextInput
                  data-autofocus
                  label={'Middle Name'}
                  error={errors.middle_name}
                  value={data.middle_name}
                  onChange={(event) => {
                    setData((prevData) => ({
                      ...prevData,
                      middle_name: event.target.value,
                    }))
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'surname') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'surname') }}>
                <XTextInput
                  label={'Surname'}
                  error={errors.surname}
                  value={data.surname}
                  onChange={(event) => {
                    setData((prevData) => ({
                      ...prevData,
                      surname: event.target.value,
                    }))
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'phone') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'phone') }}>
                <XPhoneInput
                  error={errors.phone}
                  dialCode={data.country_calling_code}
                  countryCode={data.country_code}
                  initialValue={data.phone}
                  onChange={(number, dialCode, countryCode, country) => {
                    setData((prevData) => ({
                      ...prevData,
                      phone: number,
                      country_calling_code: dialCode,
                      country_code: countryCode,
                      country: country,
                    }))
                  }}
                  checkMobileRemoteValidation={true}
                ></XPhoneInput>
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'national_id') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'national_id') }}>
                <XNationalInput
                  label={auth.agency.id === 1111181 ? 'Civil ID' : 'National ID'}
                  error={errors.national_id}
                  value={data.national_id}
                  onChange={(event) => {
                    setData((prevData) => ({
                      ...prevData,
                      national_id: event.target.value,
                    }))
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'email') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'email') }}>
                <XTextInput
                  label={'Email'}
                  error={errors.email}
                  value={data.email}
                  onChange={(event) => {
                    setData((prevData) => ({
                      ...prevData,
                      email: event.target.value,
                    }))
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'branch_id') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'branch_id') }}>
                <XSelect
                  searchable
                  required
                  label="Select Branch"
                  value={data.branch_id}
                  error={errors.branch_id}
                  data={auth.user.branches.map((branch) => {
                    return {
                      value: branch.id.toString(),
                      label: branch.branch_name,
                    }
                  })}
                  onChange={(value) => {
                    if (value) {
                      setData((prevData) => ({
                        ...prevData,
                        branch_id: value,
                      }))
                    }
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'counsellor_id') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'counsellor_id') }}>
                <XSelectWithRole
                  searchable
                  required
                  label="Select Lead Manager"
                  value={data.counsellor_id}
                  error={errors.counsellor_id}
                  data={counsellorData}
                  onChange={(value) => {
                    if (value) {
                      setData((prevData) => ({
                        ...prevData,
                        counsellor_id: value,
                      }))
                    }
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'lead_source') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'lead_source') }}>
                <XSelect
                  searchable
                  required
                  label={'Lead Source'}
                  error={errors.lead_source}
                  value={data.lead_source}
                  onInit={(callback) => {
                    axios
                      .post('/select/meta-options', {
                        entity_name: 'leads',
                        column_name: 'lead_source',
                      })
                      .then((response) => {
                        callback(response.data)
                      })
                      .catch(() => {
                        callback([])
                      })
                  }}
                  onChange={(value) => {
                    if (value) {
                      setData((prevData) => ({
                        ...prevData,
                        lead_source: value,
                      }))
                    }
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'sub_lead_source') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'sub_lead_source') }}>
                <XTextInput
                  label={'Sub Lead Source'}
                  error={errors.sub_lead_source}
                  value={data.sub_lead_source}
                  onChange={(event) => {
                    setData((prevData) => ({
                      ...prevData,
                      sub_lead_source: event.target.value,
                    }))
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'gender') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'gender') }}>
                <XSelect
                  searchable
                  label={'Gender'}
                  error={errors.gender}
                  value={data.gender}
                  data={['Male', 'Female', 'Gender Fluid/Non Binary']}
                  onChange={(value) => {
                    if (value) {
                      setData((prevData) => ({
                        ...prevData,
                        gender: value,
                      }))
                    }
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'date_of_birth') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'date_of_birth') }}>
                <XDatePicker
                  clearable
                  dateParser={(dateString) => {
                    return moment(dateString, 'DD/MM/YYYY').toDate()
                  }}
                  value={data.date_of_birth ? moment(data.date_of_birth as string, 'YYYY-MM-DD').toDate() : null}
                  width="100%"
                  placeholder="DD/MM/YYYY"
                  valueFormat={'DD/MM/YYYY'}
                  maxDate={new Date()}
                  label={'Date of Birth'}
                  onChange={(value) => {
                    if (value) {
                      setData((prevData) => ({
                        ...prevData,
                        date_of_birth: moment(value).format('YYYY-MM-DD'),
                      }))
                    } else {
                      setData((prevData) => ({
                        ...prevData,
                        date_of_birth: '',
                      }))
                    }
                  }}
                  error={errors.date_of_birth}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'marital_status') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'marital_status') }}>
                <XSelect
                  searchable
                  label={'Marital Status'}
                  error={errors.martial_status}
                  value={data.martial_status}
                  data={['Married', 'Not Married']}
                  onChange={(value) => {
                    if (value) {
                      setData((prevData) => ({
                        ...prevData,
                        martial_status: value,
                      }))
                    }
                  }}
                />
              </HStack>
            )}

            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'visa_type') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'visa_type') }}>
                <XSelect
                  searchable
                  label={'Visa Type'}
                  error={errors.visa_type}
                  value={data.visa_type}
                  onInit={(callback) => {
                    axios
                      .post('/select/meta-options', {
                        entity_name: 'leads',
                        column_name: 'visa_type',
                      })
                      .then((response) => {
                        callback(response.data)
                      })
                      .catch(() => {
                        callback([])
                      })
                  }}
                  onChange={(value) => {
                    if (value) {
                      setData((prevData) => ({
                        ...prevData,
                        visa_type: value,
                      }))
                    }
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'tag') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'tag') }}>
                <XSelect
                  searchable
                  label={'Lead Tag'}
                  error={errors.tag}
                  value={data.tag}
                  onInit={(callback) => {
                    axios
                      .post('/select/meta-options', {
                        entity_name: 'leads',
                        column_name: 'tags',
                      })
                      .then((response) => {
                        callback(response.data)
                      })
                      .catch(() => {
                        callback([])
                      })
                  }}
                  onChange={(value) => {
                    if (value) {
                      setData((prevData) => ({
                        ...prevData,
                        tag: value,
                      }))
                    }
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'alternate_phone') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'alternate_phone') }}>
                <XPhoneInput
                  label={'Alternate Phone'}
                  error={errors.alternate_phone}
                  dialCode={data.country_calling_code}
                  countryCode={data.country_code}
                  initialValue={data.alternate_phone}
                  onChange={(number, dialCode, countryCode, country) => {
                    setData((prevData) => ({
                      ...prevData,
                      alternate_phone: number,
                      country_calling_code: dialCode,
                      country_code: countryCode,
                      country: country,
                    }))
                  }}
                  checkMobileRemoteValidation={true}
                ></XPhoneInput>
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'address') && (
              <HStack
                className={'col-span-2'}
                style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'address') }}
              >
                <XTextInput
                  label={'Address'}
                  error={errors.permanent_address}
                  value={data.permanent_address}
                  onChange={(event) => {
                    setData((prevData) => ({
                      ...prevData,
                      permanent_address: event.target.value,
                    }))
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'country') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'country') }}>
                <XSelect
                  searchable
                  label={'Country'}
                  error={errors.country}
                  value={data.country_code}
                  data={countries}
                  onChange={(value) => {
                    if (value) {
                      setData((prevData) => ({
                        ...prevData,
                        country_code: value,
                        country: countries.find((country) => country.value === value)?.label as string,
                      }))
                    }
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'state') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'state') }}>
                <XTextInput
                  label={'State'}
                  error={errors.permanent_state}
                  value={data.permanent_state}
                  onChange={(event) => {
                    setData((prevData) => ({
                      ...prevData,
                      permanent_state: event.target.value,
                    }))
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'city') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'city') }}>
                <XTextInput
                  label={'City'}
                  error={errors.permanent_city}
                  value={data.permanent_city}
                  onChange={(event) => {
                    setData((prevData) => ({
                      ...prevData,
                      permanent_city: event.target.value,
                    }))
                  }}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'pincode') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'pincode') }}>
                <XTextInput
                  label={'Pincode'}
                  error={errors.permanent_pincode}
                  value={data.permanent_pincode}
                  onChange={(event) => {
                    setData((prevData) => ({
                      ...prevData,
                      permanent_pincode: event.target.value,
                    }))
                  }}
                />
              </HStack>
            )}

            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'marriage_date') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'marriage_date') }}>
                <XDatePicker
                  clearable
                  dateParser={(dateString) => {
                    return moment(dateString, 'DD/MM/YYYY').toDate()
                  }}
                  value={data.marriage_date ? moment(data.marriage_date as string, 'YYYY-MM-DD').toDate() : null}
                  width="100%"
                  placeholder="DD/MM/YYYY"
                  valueFormat={'DD/MM/YYYY'}
                  label={'Marriage Anniversary'}
                  maxDate={new Date()}
                  onChange={(value) => {
                    if (value) {
                      setData((prevData) => ({
                        ...prevData,
                        marriage_date: moment(value).format('YYYY-MM-DD'),
                      }))
                    } else {
                      setData((prevData) => ({
                        ...prevData,
                        marriage_date: '',
                      }))
                    }
                  }}
                  error={errors.marriage_date}
                />
              </HStack>
            )}
            {getSelectedOfFieldByLabel(fieldsData, 'personal_details', 'estimated_budget') && (
              <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'personal_details', 'estimated_budget') }}>
                <XNumberInput
                  icon={
                    <Typography variant={'body-small-bold'} color={XelaColor.Gray3}>
                      Rs
                    </Typography>
                  }
                  type={'number'}
                  label={'Estimated Budget'}
                  precision={1}
                  error={errors.estimated_budget}
                  defaultValue={data.estimated_budget}
                  onChange={(value) => {
                    if (value !== null) {
                      setData((prevData) => ({
                        ...prevData,
                        estimated_budget: value,
                      }))
                    }
                  }}
                />
              </HStack>
            )}
          </div>
        </VStack>
        {formCategory.preference_details && (
          <VStack spacing={'12px'}>
            <Divider variant={'dotted'} />
            <Typography color={XelaColor.Blue3} variant={'body-small-bold'}>
              Preference Details
            </Typography>

            <div className="grid grid-cols-2 w-full gap-4 items-start p-[1px]">
              {getSelectedOfFieldByLabel(fieldsData, 'preference_details', 'preferred_country') && (
                <HStack
                  style={{ order: getOrderOfFieldByLabel(fieldsData, 'preference_details', 'preferred_country') }}
                >
                  <XSelect
                    clearable={true}
                    searchable
                    label={'Preferred Country'}
                    error={errors.preferred_country}
                    value={data.preferred_country_code}
                    data={countries}
                    onChange={(value) => {
                      if (value) {
                        setData((prevData) => ({
                          ...prevData,
                          preferred_country_code: value,
                          preferred_country: countries.find((country) => country.value === value)?.label as string,
                        }))
                      }
                    }}
                  />
                </HStack>
              )}
              {getSelectedOfFieldByLabel(fieldsData, 'preference_details', 'second_preferred_country') && (
                <HStack
                  style={{
                    order: getOrderOfFieldByLabel(fieldsData, 'preference_details', 'second_preferred_country'),
                  }}
                >
                  <XSelect
                    clearable={true}
                    searchable
                    label={'Second Preferred Country'}
                    error={errors.second_preferred_country}
                    value={data.second_preferred_country_code}
                    data={secondCountries}
                    onChange={(value) => {
                      if (value) {
                        setData((prevData) => ({
                          ...prevData,
                          second_preferred_country_code: value,
                          second_preferred_country: secondCountries.find((country) => country.value === value)
                            ?.label as string,
                        }))
                      }
                    }}
                  />
                </HStack>
              )}
              {getSelectedOfFieldByLabel(fieldsData, 'preference_details', 'third_preferred_country') && (
                <HStack
                  style={{ order: getOrderOfFieldByLabel(fieldsData, 'preference_details', 'third_preferred_country') }}
                >
                  <XSelect
                    clearable={true}
                    searchable
                    label={'Third Preferred Country'}
                    error={errors.third_preferred_country}
                    value={data.third_preferred_country_code}
                    data={thirdCountries}
                    onChange={(value) => {
                      if (value) {
                        setData((prevData) => ({
                          ...prevData,
                          third_preferred_country_code: value,
                          third_preferred_country: thirdCountries.find((country) => country.value === value)
                            ?.label as string,
                        }))
                      }
                    }}
                  />
                </HStack>
              )}
              {getSelectedOfFieldByLabel(fieldsData, 'preference_details', 'preferred_course_type') && (
                <HStack
                  style={{ order: getOrderOfFieldByLabel(fieldsData, 'preference_details', 'preferred_course_type') }}
                >
                  <XSelect
                    searchable
                    label={'Preferred Course Type'}
                    error={errors.preferred_course_type}
                    value={data.preferred_course_type}
                    onInit={(callback) => {
                      axios
                        .post('/select/meta-options', {
                          entity_name: 'leads',
                          column_name: 'preferred_course_type',
                        })
                        .then((response) => {
                          callback(response.data)
                        })
                        .catch((error) => {
                          console.log(error)
                          callback([])
                        })
                    }}
                    onChange={(value) => {
                      if (value) {
                        setData((prevData) => ({
                          ...prevData,
                          preferred_course_type: value,
                        }))
                      }
                    }}
                  />
                </HStack>
              )}
              {getSelectedOfFieldByLabel(fieldsData, 'preference_details', 'preferred_course_name') && (
                <HStack
                  style={{ order: getOrderOfFieldByLabel(fieldsData, 'preference_details', 'preferred_course_name') }}
                >
                  <XTextInput
                    label={'Preferred Course Name'}
                    error={errors.preferred_course_name}
                    value={data.preferred_course_name}
                    onChange={(event) => {
                      setData((prevData) => ({
                        ...prevData,
                        preferred_course_name: event.target.value,
                      }))
                    }}
                  />
                </HStack>
              )}
              {getSelectedOfFieldByLabel(fieldsData, 'preference_details', 'other_country') && (
                <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'preference_details', 'other_country') }}>
                  <XTextInput
                    label={'Other Country'}
                    error={errors.other_country}
                    value={data.other_country}
                    onChange={(event) => {
                      setData((prevData) => ({
                        ...prevData,
                        other_country: event.target.value,
                      }))
                    }}
                  />
                </HStack>
              )}
              {getSelectedOfFieldByLabel(fieldsData, 'preference_details', 'travel_history') && (
                <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'preference_details', 'travel_history') }}>
                  <XTextInput
                    label={'Travel History'}
                    error={errors.travel_history}
                    value={data.travel_history}
                    onChange={(event) => {
                      setData((prevData) => ({
                        ...prevData,
                        travel_history: event.target.value,
                      }))
                    }}
                  />
                </HStack>
              )}
              {getSelectedOfFieldByLabel(fieldsData, 'preference_details', 'accommodation') && (
                <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'preference_details', 'accommodation') }}>
                  <XTextInput
                    label={'Accommodation'}
                    error={errors.accommodation}
                    value={data.accommodation}
                    onChange={(event) => {
                      setData((prevData) => ({
                        ...prevData,
                        accommodation: event.target.value,
                      }))
                    }}
                  />
                </HStack>
              )}
            </div>
          </VStack>
        )}
        {formCategory.education_details && (
          <VStack spacing={'12px'}>
            <Divider variant={'dotted'} />
            <Typography color={XelaColor.Blue3} variant={'body-small-bold'}>
              Education Details
            </Typography>

            <Tabs
              style={{
                width: '100%',
                borderBottomWidth: '2px',
                borderBottomStyle: 'solid',
                borderBottomColor: XelaColor.Gray12,
              }}
              items={educationTabArrangement
                .filter((tab) => getSelectedOfFieldByLabel(fieldsData, 'education_details', tab.fieldName))
                .map((tab) => new TabItem(tab.label, tab.value))}
              name="educational_details_tabs"
              defaultValue={educationTab}
              onChangeHandle={(value) => {
                setEducationTab(value)
              }}
            ></Tabs>
            {educationTab === 'Tenth' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      max={moment().year()}
                      data-autofocus
                      type={'number'}
                      label={'Tenth Year'}
                      error={errors.tenth_year}
                      defaultValue={data.tenth_year}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          tenth_year: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XSelect
                      searchable
                      label={'Tenth Board'}
                      error={errors.tenth_board}
                      value={data.tenth_board}
                      onInit={(callback) => {
                        axios
                          .post('/select/meta-options', {
                            entity_name: 'leads',
                            column_name: 'education_boards',
                          })
                          .then((response) => {
                            callback(response.data)
                          })
                          .catch((error) => {
                            console.log(error)
                            callback([])
                          })
                      }}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            tenth_board: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      max={100}
                      type={'number'}
                      precision={2}
                      label={'Tenth Percentage/CGPA'}
                      error={errors.tenth_percentage}
                      defaultValue={data.tenth_percentage}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          tenth_percentage: value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XTextInput
                      label={'Tenth School Name'}
                      error={errors.tenth_school_name}
                      value={data.tenth_school_name}
                      onChange={(e) => {
                        setData((prevData) => ({
                          ...prevData,
                          tenth_school_name: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      label={'Tenth Medium of Instruction'}
                      error={errors.tenth_medium_of_instruction}
                      value={data.tenth_medium_of_instruction}
                      onChange={(e) => {
                        setData((prevData) => ({
                          ...prevData,
                          tenth_medium_of_instruction: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XDatePicker
                      clearable
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        data.tenth_result_date ? moment(data.tenth_result_date as string, 'YYYY-MM-DD').toDate() : null
                      }
                      width="100%"
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Tenth Result Date'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            tenth_result_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            tenth_result_date: '',
                          }))
                        }
                      }}
                      error={errors.tenth_result_date}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
            {educationTab === 'Twelfth' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      max={moment().year()}
                      type={'number'}
                      label={'Twelfth Year'}
                      error={errors.twelfth_year}
                      defaultValue={data.twelfth_year}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          twelfth_year: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XSelect
                      searchable
                      label={'Twelfth Board'}
                      error={errors.twelfth_board}
                      value={data.twelfth_board}
                      onInit={(callback) => {
                        axios
                          .post('/select/meta-options', {
                            entity_name: 'leads',
                            column_name: 'education_boards',
                          })
                          .then((response) => {
                            callback(response.data)
                          })
                          .catch((error) => {
                            console.log(error)
                            callback([])
                          })
                      }}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            twelfth_board: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      max={100}
                      type={'number'}
                      precision={2}
                      label={'Twelfth Percentage/CGPA'}
                      error={errors.twelfth_percentage}
                      defaultValue={data.twelfth_percentage}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          twelfth_percentage: value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XSelect
                      label={'Twelfth Stream'}
                      error={errors.twelfth_stream}
                      value={data.twelfth_stream}
                      data={['Arts', 'Commerce', 'Medicine', 'Non-Medicine', 'Science', 'Others']}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            twelfth_stream: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      label={'Twelfth School Name'}
                      error={errors.twelfth_school_name}
                      value={data.twelfth_school_name}
                      onChange={(e) => {
                        setData((prevData) => ({
                          ...prevData,
                          twelfth_school_name: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      label={'Twelfth Medium of Instruction'}
                      error={errors.twelfth_medium_of_instruction}
                      value={data.twelfth_medium_of_instruction}
                      onChange={(e) => {
                        setData((prevData) => ({
                          ...prevData,
                          twelfth_medium_of_instruction: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XTextInput
                      label={'Twelfth English Marks'}
                      error={errors.twelfth_english_marks}
                      value={data.twelfth_english_marks}
                      onChange={(e) => {
                        setData((prevData) => ({
                          ...prevData,
                          twelfth_english_marks: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XDatePicker
                      clearable
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        data.twelfth_result_date
                          ? moment(data.twelfth_result_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Twelfth Result Date'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            twelfth_result_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            twelfth_result_date: '',
                          }))
                        }
                      }}
                      error={errors.twelfth_result_date}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
            {educationTab === 'Bachelors' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      max={moment().year()}
                      type={'number'}
                      label={'Bachelor Year'}
                      error={errors.bachelor_one_year}
                      defaultValue={data.bachelor_one_year}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          bachelor_one_year: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      label={'College/University'}
                      error={errors.bachelor_one_college}
                      value={data.bachelor_one_college}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          bachelor_one_college: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      label={'Course Name'}
                      error={errors.bachelor_one_course}
                      value={data.bachelor_one_course}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          bachelor_one_course: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      max={100}
                      type={'number'}
                      precision={2}
                      label={'Percentage/CGPA'}
                      error={errors.bachelor_one_percentage}
                      defaultValue={data.bachelor_one_percentage}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          bachelor_one_percentage: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      max={20}
                      type={'number'}
                      label={'No of Reappears'}
                      error={errors.bachelor_one_reappears}
                      defaultValue={data.bachelor_one_reappears}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          bachelor_one_reappears: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XSelect
                      label={'Duration'}
                      error={errors.bachelor_one_duration}
                      value={data.bachelor_one_duration}
                      data={['3 yr', '4 yr', '5 yr']}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            bachelor_one_duration: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing={'16px'} alignItems="flex-start" width={'66%'}>
                  <HStack>
                    <XTextInput
                      label={'Medium of Instruction'}
                      error={errors.bachelor_one_medium_of_instruction}
                      value={data.bachelor_one_medium_of_instruction}
                      onChange={(e) => {
                        setData((prevData) => ({
                          ...prevData,
                          bachelor_one_medium_of_instruction: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XDatePicker
                      clearable
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        data.bachelor_one_result_date
                          ? moment(data.bachelor_one_result_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Result Date'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            bachelor_one_result_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            bachelor_one_result_date: '',
                          }))
                        }
                      }}
                      error={errors.bachelor_one_result_date}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
            {educationTab === 'Masters' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      max={moment().year()}
                      type={'number'}
                      label={'Master Year'}
                      error={errors.master_one_year}
                      defaultValue={data.master_one_year}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          master_one_year: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      label={'College/University'}
                      error={errors.master_one_college}
                      value={data.master_one_college}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          master_one_college: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      label={'Course Name'}
                      error={errors.master_one_course}
                      value={data.master_one_course}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          master_one_course: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      max={100}
                      type={'number'}
                      precision={2}
                      label={'Percentage/CGPA'}
                      error={errors.master_one_percentage}
                      defaultValue={data.master_one_percentage}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          master_one_percentage: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      max={20}
                      type={'number'}
                      label={'No of Reappears'}
                      error={errors.master_one_reappears}
                      defaultValue={data.master_one_reappears}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          master_one_reappears: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XSelect
                      label={'Duration'}
                      error={errors.master_one_duration}
                      value={data.master_one_duration}
                      data={['1 yr', '2 yr', '3 yr']}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            master_one_duration: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing={'16px'} alignItems="flex-start" width={'67%'}>
                  <HStack>
                    <XTextInput
                      label={'Medium of Instruction'}
                      error={errors.master_one_medium_of_instruction}
                      value={data.master_one_medium_of_instruction}
                      onChange={(e) => {
                        setData((prevData) => ({
                          ...prevData,
                          master_one_medium_of_instruction: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XDatePicker
                      clearable
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        data.master_one_result_date
                          ? moment(data.master_one_result_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Result Date'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            master_one_result_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            master_one_result_date: '',
                          }))
                        }
                      }}
                      error={errors.master_one_result_date}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
            {educationTab === 'Diplomas' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      max={moment().year()}
                      type={'number'}
                      label={'Diploma Year'}
                      error={errors.diploma_one_year}
                      defaultValue={data.diploma_one_year}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          diploma_one_year: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      label={'College/University'}
                      error={errors.diploma_one_college}
                      value={data.diploma_one_college}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          diploma_one_college: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      label={'Course Name'}
                      error={errors.diploma_one_course}
                      value={data.diploma_one_course}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          diploma_one_course: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      max={100}
                      type={'number'}
                      precision={2}
                      label={'Percentage/CGPA'}
                      error={errors.diploma_one_percentage}
                      defaultValue={data.diploma_one_percentage}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          diploma_one_percentage: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      max={20}
                      type={'number'}
                      label={'No of Reappears'}
                      error={errors.diploma_one_reappears}
                      defaultValue={data.diploma_one_reappears}
                      onChange={(value) => {
                        setData((prevData) => ({
                          ...prevData,
                          diploma_one_reappears: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XSelect
                      label={'Duration'}
                      error={errors.diploma_one_duration}
                      value={data.diploma_one_duration}
                      data={['1 yr', '2 yr', '3 yr']}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            diploma_one_duration: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing={'16px'} alignItems="flex-start">
                  <HStack>
                    <XSelect
                      label={'Level'}
                      error={errors.diploma_one_level}
                      value={data.diploma_one_level}
                      data={['12th', 'UG', 'PG']}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            diploma_one_level: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      label={'Medium of Instruction'}
                      error={errors.diploma_one_medium_of_instruction}
                      value={data.diploma_one_medium_of_instruction}
                      onChange={(e) => {
                        setData((prevData) => ({
                          ...prevData,
                          diploma_one_medium_of_instruction: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XDatePicker
                      clearable
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        data.diploma_one_result_date
                          ? moment(data.diploma_one_result_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Result Date'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            diploma_one_result_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            diploma_one_result_date: '',
                          }))
                        }
                      }}
                      error={errors.diploma_one_result_date}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
            {educationTab === 'Others' && (
              <VStack spacing="12px">
                <HStack>
                  <XTextarea
                    minRows={4}
                    label={'Other Educations'}
                    error={errors.other_educations}
                    value={data.other_educations}
                    onChange={(event) => {
                      setData((prevData) => ({
                        ...prevData,
                        other_educations: event.target.value,
                      }))
                    }}
                  />
                </HStack>
              </VStack>
            )}
          </VStack>
        )}
        {formCategory.language_aptitude_test_details && (
          <VStack spacing={'12px'}>
            <Divider variant={'dotted'} />
            <Typography color={XelaColor.Blue3} variant={'body-small-bold'}>
              Language Aptitude Test Details
            </Typography>

            <Tabs
              style={{
                width: '100%',
                borderBottomWidth: '2px',
                borderBottomStyle: 'solid',
                borderBottomColor: XelaColor.Gray12,
              }}
              items={languageTabArrangement
                .filter((tab) => getSelectedOfFieldByLabel(fieldsData, 'language_aptitude_test_details', tab.fieldName))
                .map((tab) => new TabItem(tab.label, tab.value))}
              name="language_aptitude_details_tabs"
              defaultValue={languageTab}
              onChangeHandle={(value) => {
                setLanguageTab(value)
              }}
            ></Tabs>
            {languageTab === 'IELTS' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XDatePicker
                      clearable
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        data.language_ielts_test_date
                          ? moment(data.language_ielts_test_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      width="100%"
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Test Date'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            language_ielts_test_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            language_ielts_test_date: '',
                          }))
                        }
                      }}
                      error={errors.language_ielts_test_date}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Overall Score'}
                      precision={1}
                      error={errors.language_ielts_overall_score}
                      defaultValue={data.language_ielts_overall_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_ielts_overall_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Listening Score'}
                      precision={1}
                      error={errors.language_ielts_listening_score}
                      defaultValue={data.language_ielts_listening_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_ielts_listening_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Reading Score'}
                      precision={1}
                      error={errors.language_ielts_reading_score}
                      defaultValue={data.language_ielts_reading_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_ielts_reading_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Writing Score'}
                      precision={1}
                      error={errors.language_ielts_writing_score}
                      defaultValue={data.language_ielts_writing_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_ielts_writing_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Speaking Score'}
                      precision={1}
                      error={errors.language_ielts_speaking_score}
                      defaultValue={data.language_ielts_speaking_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_ielts_speaking_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
            {languageTab === 'TOEFL' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XDatePicker
                      clearable
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        data.language_toefl_test_date
                          ? moment(data.language_toefl_test_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      width="100%"
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Test Date'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            language_toefl_test_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            language_toefl_test_date: '',
                          }))
                        }
                      }}
                      error={errors.language_toefl_test_date}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Overall Score'}
                      precision={2}
                      error={errors.language_toefl_overall_score}
                      defaultValue={data.language_toefl_overall_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_toefl_overall_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Reading Score'}
                      precision={2}
                      error={errors.language_toefl_reading_score}
                      defaultValue={data.language_toefl_reading_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_toefl_reading_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Listening Score'}
                      precision={2}
                      error={errors.language_toefl_listening_score}
                      defaultValue={data.language_toefl_listening_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_toefl_listening_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Speaking Score'}
                      precision={2}
                      error={errors.language_toefl_speaking_score}
                      defaultValue={data.language_toefl_speaking_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_toefl_speaking_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Writing Score'}
                      precision={2}
                      error={errors.language_toefl_writing_score}
                      defaultValue={data.language_toefl_writing_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_toefl_writing_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
            {languageTab === 'PTE' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XDatePicker
                      clearable
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        data.language_pte_test_date
                          ? moment(data.language_pte_test_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      width="100%"
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Test Date'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            language_pte_test_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            language_pte_test_date: '',
                          }))
                        }
                      }}
                      error={errors.language_pte_test_date}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Overall Score'}
                      precision={2}
                      error={errors.language_pte_overall_score}
                      defaultValue={data.language_pte_overall_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_pte_overall_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Listening Score'}
                      precision={2}
                      error={errors.language_pte_listening_score}
                      defaultValue={data.language_pte_listening_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_pte_listening_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Speaking Score'}
                      precision={2}
                      error={errors.language_pte_speaking_score}
                      defaultValue={data.language_pte_speaking_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_pte_speaking_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Reading Score'}
                      precision={2}
                      error={errors.language_pte_reading_score}
                      defaultValue={data.language_pte_reading_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_pte_reading_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Writing Score'}
                      precision={2}
                      error={errors.language_pte_writing_score}
                      defaultValue={data.language_pte_writing_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_pte_writing_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
            {languageTab === 'GRE' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XDatePicker
                      clearable
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        data.aptitude_gre_test_date
                          ? moment(data.aptitude_gre_test_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      width="100%"
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Test Date'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_gre_test_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_gre_test_date: '',
                          }))
                        }
                      }}
                      error={errors.aptitude_gre_test_date}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Overall Score'}
                      precision={2}
                      error={errors.aptitude_gre_overall_score}
                      defaultValue={data.aptitude_gre_overall_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_gre_overall_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Verbal Score'}
                      precision={2}
                      error={errors.aptitude_gre_verbal_score}
                      defaultValue={data.aptitude_gre_verbal_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_gre_verbal_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Quantitative Score'}
                      precision={2}
                      error={errors.aptitude_gre_quantitative_score}
                      defaultValue={data.aptitude_gre_quantitative_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_gre_quantitative_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Analytical Score'}
                      precision={2}
                      error={errors.aptitude_gre_analytical_score}
                      defaultValue={data.aptitude_gre_analytical_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_gre_analytical_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <div style={{ width: '100%' }}></div>
                </HStack>
              </VStack>
            )}
            {languageTab === 'GMAT' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XDatePicker
                      clearable
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        data.aptitude_gmat_test_date
                          ? moment(data.aptitude_gmat_test_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      width="100%"
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Test Date'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_gmat_test_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_gmat_test_date: '',
                          }))
                        }
                      }}
                      error={errors.aptitude_gmat_test_date}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Overall Score'}
                      precision={2}
                      error={errors.aptitude_gmat_overall_score}
                      defaultValue={data.aptitude_gmat_overall_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_gmat_overall_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Verbal Score'}
                      precision={2}
                      error={errors.aptitude_gmat_verbal_score}
                      defaultValue={data.aptitude_gmat_verbal_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_gmat_verbal_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Quantitative Score'}
                      precision={2}
                      error={errors.aptitude_gmat_quantitative_score}
                      defaultValue={data.aptitude_gmat_quantitative_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_gmat_quantitative_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
            {languageTab === 'SAT' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XDatePicker
                      clearable
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        data.aptitude_sat_test_date
                          ? moment(data.aptitude_sat_test_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      width="100%"
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Test Date'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_sat_test_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_sat_test_date: '',
                          }))
                        }
                      }}
                      error={errors.aptitude_sat_test_date}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Overall Score'}
                      precision={2}
                      error={errors.aptitude_sat_overall_score}
                      defaultValue={data.aptitude_sat_overall_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_sat_overall_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'English Score'}
                      precision={2}
                      error={errors.aptitude_sat_english_score}
                      defaultValue={data.aptitude_sat_english_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_sat_english_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Math Score'}
                      precision={2}
                      error={errors.aptitude_sat_math_score}
                      defaultValue={data.aptitude_sat_math_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            aptitude_sat_math_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
            {languageTab === 'DUOLINGO' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XTextInput
                      label={'Login ID'}
                      error={errors.language_duolingo_login_id}
                      value={data.language_duolingo_login_id}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          language_duolingo_login_id: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      label={'Password'}
                      error={errors.language_duolingo_login_password}
                      value={data.language_duolingo_login_password}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          language_duolingo_login_password: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XDatePicker
                      clearable
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        data.language_duolingo_test_date
                          ? moment(data.language_duolingo_test_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      width="100%"
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Test Date'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            language_duolingo_test_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            language_duolingo_test_date: '',
                          }))
                        }
                      }}
                      error={errors.language_duolingo_test_date}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Overall Score'}
                      precision={1}
                      error={errors.language_duolingo_overall_score}
                      defaultValue={data.language_duolingo_overall_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_duolingo_overall_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Listening Score'}
                      precision={1}
                      error={errors.language_duolingo_listening_score}
                      defaultValue={data.language_duolingo_listening_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_duolingo_listening_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Reading Score'}
                      precision={1}
                      error={errors.language_duolingo_reading_score}
                      defaultValue={data.language_duolingo_reading_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_duolingo_reading_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Writing Score'}
                      precision={1}
                      error={errors.language_duolingo_writing_score}
                      defaultValue={data.language_duolingo_writing_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_duolingo_writing_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XNumberInput
                      type={'number'}
                      label={'Speaking Score'}
                      precision={1}
                      error={errors.language_duolingo_speaking_score}
                      defaultValue={data.language_duolingo_speaking_score}
                      onChange={(value) => {
                        if (value !== null) {
                          setData((prevData) => ({
                            ...prevData,
                            language_duolingo_speaking_score: value,
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
          </VStack>
        )}
        {formCategory.passport_details && (
          <VStack spacing={'12px'}>
            <Divider variant={'dotted'} />
            <Typography color={XelaColor.Blue3} variant={'body-small-bold'}>
              Passport Details
            </Typography>

            <div className="grid grid-cols-2 w-full gap-4 items-start p-[1px]">
              {getSelectedOfFieldByLabel(fieldsData, 'passport_details', 'passport_number') && (
                <HStack style={{ order: getOrderOfFieldByLabel(fieldsData, 'passport_details', 'passport_number') }}>
                  <XTextInput
                    data-autofocus
                    label={'Passport Number'}
                    error={errors.passport_number}
                    value={data.passport_number}
                    onChange={(event) => {
                      setData((prevData) => ({
                        ...prevData,
                        passport_number: event.target.value,
                      }))
                    }}
                  />
                </HStack>
              )}
              {getSelectedOfFieldByLabel(fieldsData, 'passport_details', 'passport_nationality') && (
                <HStack
                  style={{ order: getOrderOfFieldByLabel(fieldsData, 'passport_details', 'passport_nationality') }}
                >
                  <XTextInput
                    label={'Passport Nationality'}
                    error={errors.passport_nationality}
                    value={data.passport_nationality}
                    onChange={(event) => {
                      setData((prevData) => ({
                        ...prevData,
                        passport_nationality: event.target.value,
                      }))
                    }}
                  />
                </HStack>
              )}
              {getSelectedOfFieldByLabel(fieldsData, 'passport_details', 'passport_expiry_date') && (
                <HStack
                  style={{ order: getOrderOfFieldByLabel(fieldsData, 'passport_details', 'passport_expiry_date') }}
                >
                  <XDatePicker
                    clearable
                    dateParser={(dateString) => {
                      return moment(dateString, 'DD/MM/YYYY').toDate()
                    }}
                    value={
                      data.passport_expiry_date
                        ? moment(data.passport_expiry_date as string, 'YYYY-MM-DD').toDate()
                        : null
                    }
                    width="100%"
                    placeholder="DD/MM/YYYY"
                    valueFormat={'DD/MM/YYYY'}
                    label={'Passport Expiry Date'}
                    onChange={(value) => {
                      if (value) {
                        setData((prevData) => ({
                          ...prevData,
                          passport_expiry_date: moment(value).format('YYYY-MM-DD'),
                        }))
                      } else {
                        setData((prevData) => ({
                          ...prevData,
                          passport_expiry_date: '',
                        }))
                      }
                    }}
                    error={errors.passport_expiry_date}
                  />
                </HStack>
              )}

              {getSelectedOfFieldByLabel(fieldsData, 'passport_details', 'passport_issue_date') && (
                <HStack
                  style={{ order: getOrderOfFieldByLabel(fieldsData, 'passport_details', 'passport_issue_date') }}
                >
                  <XDatePicker
                    clearable
                    dateParser={(dateString) => {
                      return moment(dateString, 'DD/MM/YYYY').toDate()
                    }}
                    value={
                      data.passport_issue_date
                        ? moment(data.passport_issue_date as string, 'YYYY-MM-DD').toDate()
                        : null
                    }
                    width="100%"
                    placeholder="DD/MM/YYYY"
                    valueFormat={'DD/MM/YYYY'}
                    label={'Passport Issue Date'}
                    onChange={(value) => {
                      if (value) {
                        setData((prevData) => ({
                          ...prevData,
                          passport_issue_date: moment(value).format('YYYY-MM-DD'),
                        }))
                      } else {
                        setData((prevData) => ({
                          ...prevData,
                          passport_issue_date: '',
                        }))
                      }
                    }}
                    error={errors.passport_issue_date}
                  />
                </HStack>
              )}
              {getSelectedOfFieldByLabel(fieldsData, 'passport_details', 'passport_place_of_issue') && (
                <HStack
                  style={{ order: getOrderOfFieldByLabel(fieldsData, 'passport_details', 'passport_place_of_issue') }}
                >
                  <XTextInput
                    label={'Passport Issue Place'}
                    error={errors.passport_issue_place}
                    value={data.passport_issue_place}
                    onChange={(event) => {
                      setData((prevData) => ({
                        ...prevData,
                        passport_issue_place: event.target.value,
                      }))
                    }}
                  />
                </HStack>
              )}
              {getSelectedOfFieldByLabel(fieldsData, 'passport_details', 'passport_birth_place') && (
                <HStack
                  style={{ order: getOrderOfFieldByLabel(fieldsData, 'passport_details', 'passport_birth_place') }}
                >
                  <XTextInput
                    label={'Passport Place of Birth'}
                    error={errors.passport_birth_place}
                    value={data.passport_birth_place}
                    onChange={(event) => {
                      setData((prevData) => ({
                        ...prevData,
                        passport_birth_place: event.target.value,
                      }))
                    }}
                  />
                </HStack>
              )}
              {getSelectedOfFieldByLabel(fieldsData, 'passport_details', 'previous_passport_number') && (
                <HStack
                  style={{ order: getOrderOfFieldByLabel(fieldsData, 'passport_details', 'previous_passport_number') }}
                >
                  <XTextInput
                    label={'Previous Passport Number, if any'}
                    error={errors.previous_passport_number}
                    value={data.previous_passport_number}
                    onChange={(event) => {
                      setData((prevData) => ({
                        ...prevData,
                        previous_passport_number: event.target.value,
                      }))
                    }}
                  />
                </HStack>
              )}
            </div>
          </VStack>
        )}
        {formCategory.family_details && (
          <VStack spacing={'12px'}>
            <Divider variant={'dotted'} />
            <Typography color={XelaColor.Blue3} variant={'body-small-bold'}>
              Family Details
            </Typography>
            <Tabs
              style={{
                width: '100%',
                borderBottomWidth: '2px',
                borderBottomStyle: 'solid',
                borderBottomColor: XelaColor.Gray12,
              }}
              items={familyTabArrangement
                .filter((tab) => getSelectedOfFieldByLabel(fieldsData, 'family_details', tab.fieldName))
                .map((tab) => new TabItem(tab.label, tab.value))}
              name="family_details_edit_modal_tabs"
              defaultValue={familyTab}
              onChangeHandle={(value) => {
                setFamilyTab(value)
              }}
            ></Tabs>
            {familyTab === 'Father' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XTextInput
                      data-autofocus
                      label={'Father First Name'}
                      error={errors.father_first_name}
                      value={data.father_first_name}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          father_first_name: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      data-autofocus
                      label={'Father Last Name'}
                      error={errors.father_last_name}
                      value={data.father_last_name}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          father_last_name: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XPhoneInput
                      error={errors.father_phone}
                      dialCode={data.father_country_calling_code}
                      countryCode={data.father_country_code?.toLowerCase()}
                      initialValue={data.father_phone}
                      onChange={(number, dialCode, countryCode, country) => {
                        setData((prevData) => ({
                          ...prevData,
                          father_phone: number,
                          father_country_calling_code: dialCode,
                          father_country_code: countryCode,
                          father_country: country,
                        }))
                      }}
                    ></XPhoneInput>
                  </HStack>
                </HStack>
                <HStack spacing={'16px'} alignItems="flex-start">
                  <HStack>
                    <XTextInput
                      data-autofocus
                      label={'Father Email'}
                      error={errors.father_email}
                      value={data.father_email}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          father_email: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XDatePicker
                      clearable
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={data.father_dob ? moment(data.father_dob as string, 'YYYY-MM-DD').toDate() : null}
                      width="100%"
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Father DOB'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            father_dob: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            father_dob: '',
                          }))
                        }
                      }}
                      error={errors.father_dob}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      data-autofocus
                      label={'Father Occupation'}
                      error={errors.father_occupation}
                      value={data.father_occupation}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          father_occupation: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XTextInput
                      data-autofocus
                      label={'Father Aadhaar UID'}
                      error={errors.father_aadhaar_uid}
                      value={data.father_aadhaar_uid}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          father_aadhaar_uid: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width="200%">
                    <XTextInput
                      data-autofocus
                      label={'Father Address'}
                      error={errors.father_address}
                      value={data.father_address}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          father_address: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
            {familyTab === 'Mother' && (
              <VStack spacing="12px">
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XTextInput
                      data-autofocus
                      label={'Mother First Name'}
                      error={errors.mother_first_name}
                      value={data.mother_first_name}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          mother_first_name: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      data-autofocus
                      label={'Mother Last Name'}
                      error={errors.mother_last_name}
                      value={data.mother_last_name}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          mother_last_name: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XPhoneInput
                      label={'Mother Phone'}
                      error={errors.mother_phone}
                      dialCode={data.mother_country_calling_code}
                      countryCode={data.mother_country_code?.toLowerCase()}
                      initialValue={data.mother_phone}
                      onChange={(number, dialCode, countryCode, country) => {
                        setData((prevData) => ({
                          ...prevData,
                          mother_phone: number,
                          mother_country_calling_code: dialCode,
                          mother_country_code: countryCode,
                          mother_country: country,
                        }))
                      }}
                    ></XPhoneInput>
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XTextInput
                      data-autofocus
                      label={'Mother Email'}
                      error={errors.mother_email}
                      value={data.mother_email}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          mother_email: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack>
                    <XDatePicker
                      clearable
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={data.mother_dob ? moment(data.mother_dob as string, 'YYYY-MM-DD').toDate() : null}
                      width="100%"
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Mother DOB'}
                      onChange={(value) => {
                        if (value) {
                          setData((prevData) => ({
                            ...prevData,
                            mother_dob: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            mother_dob: '',
                          }))
                        }
                      }}
                      error={errors.mother_dob}
                    />
                  </HStack>
                  <HStack>
                    <XTextInput
                      data-autofocus
                      label={'Mother Occupation'}
                      error={errors.mother_occupation}
                      value={data.mother_occupation}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          mother_occupation: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" alignItems="flex-start">
                  <HStack>
                    <XTextInput
                      data-autofocus
                      label={'Mother Aadhaar UID'}
                      error={errors.mother_aadhaar_uid}
                      value={data.mother_aadhaar_uid}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          mother_aadhaar_uid: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width="200%">
                    <XTextInput
                      data-autofocus
                      label={'Mother Address'}
                      error={errors.mother_address}
                      value={data.mother_address}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          mother_address: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
              </VStack>
            )}
          </VStack>
        )}
        {formCategory.visa_details && (
          <VStack spacing={'12px'}>
            <Divider variant={'dotted'} />
            <Typography color={XelaColor.Blue3} variant={'body-small-bold'}>
              Visa Details
            </Typography>
            <HStack>
              <Checkbox
                label={'Is Visa Rejected in Past'}
                color={'blueX'}
                checked={data.is_visa_rejected_in_past}
                onChange={(event) => {
                  setData((prevData) => ({
                    ...prevData,
                    is_visa_rejected_in_past: event.target.checked,
                  }))
                }}
              />
            </HStack>
            {data.is_visa_rejected_in_past && (
              <HStack spacing={'12px'}>
                <XSelect
                  searchable
                  data={Object.values(COUNTRY_FORMATS)}
                  label={'Rejection Country'}
                  value={data.visa_rejection_one_country}
                  error={errors.visa_rejection_one_country}
                  onChange={(value) => {
                    if (value) {
                      setData((prevData) => ({
                        ...prevData,
                        visa_rejection_one_country: value,
                      }))
                    }
                  }}
                />
                <XNumberInput
                  type={'number'}
                  label={'Rejection Year'}
                  error={errors.visa_rejection_one_year}
                  defaultValue={data.visa_rejection_one_year}
                  onChange={(value) => {
                    setData((prevData) => ({
                      ...prevData,
                      visa_rejection_one_year: value,
                    }))
                  }}
                />
                <XTextInput
                  label={'Rejection Reason'}
                  error={errors.visa_rejection_one_reason}
                  value={data.visa_rejection_one_reason}
                  onChange={(event) => {
                    setData((prevData) => ({
                      ...prevData,
                      visa_rejection_one_reason: event.target.value,
                    }))
                  }}
                />
              </HStack>
            )}
          </VStack>
        )}
        {formCategory.work_experience && (
          <VStack spacing={'12px'}>
            <Divider variant={'dotted'} />
            <Typography color={XelaColor.Blue3} variant={'body-small-bold'}>
              Work Experiences
            </Typography>
            <VStack spacing="12px">
              <HStack spacing="12px" alignItems="flex-start">
                <HStack>
                  <XTextInput
                    data-autofocus
                    label={'Company Name'}
                    error={errors.work_experience_one_company_name}
                    value={data.work_experience_one_company_name}
                    onChange={(event) => {
                      setData((prevData) => ({
                        ...prevData,
                        work_experience_one_company_name: event.target.value,
                      }))
                    }}
                  />
                </HStack>
                <HStack>
                  <XTextInput
                    label={'Job Title'}
                    error={errors.work_experience_one_job_title}
                    value={data.work_experience_one_job_title}
                    onChange={(event) => {
                      setData((prevData) => ({
                        ...prevData,
                        work_experience_one_job_title: event.target.value,
                      }))
                    }}
                  />
                </HStack>
              </HStack>
              <VStack spacing="12px" alignItems="flex-start">
                <HStack>
                  <Divider variant={'dotted'} color={XelaColor.Gray11}></Divider>
                </HStack>
                <HStack>
                  <HStack>
                    <Checkbox
                      label={'I am currently working in this role.'}
                      color={'blueX'}
                      checked={data.work_experience_one_is_still_working}
                      onChange={(event) => {
                        setData((prevData) => ({
                          ...prevData,
                          work_experience_one_is_still_working: event.target.checked,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
              </VStack>
              <HStack spacing="12px" alignItems="flex-start">
                <HStack>
                  <XDatePicker
                    clearable
                    dateParser={(dateString) => {
                      return moment(dateString, 'MM/YYYY').toDate()
                    }}
                    value={
                      data.work_experience_one_start_date
                        ? moment(data.work_experience_one_start_date as string, 'YYYY-MM').toDate()
                        : null
                    }
                    width="100%"
                    placeholder="MM/YYYY"
                    valueFormat={'MM/YYYY'}
                    label={'Start Date'}
                    onChange={(value) => {
                      if (value) {
                        setData((prevData) => ({
                          ...prevData,
                          work_experience_one_start_date: moment(value).format('YYYY-MM'),
                        }))
                      } else {
                        setData((prevData) => ({
                          ...prevData,
                          work_experience_one_start_date: '',
                        }))
                      }
                    }}
                    error={errors.work_experience_one_start_date}
                  />
                </HStack>
                <HStack>
                  <XDatePicker
                    clearable
                    disabled={data.work_experience_one_is_still_working}
                    dateParser={(dateString) => {
                      return moment(dateString, 'MM/YYYY').toDate()
                    }}
                    value={
                      data.work_experience_one_end_date
                        ? moment(data.work_experience_one_end_date as string, 'YYYY-MM').toDate()
                        : null
                    }
                    width="100%"
                    placeholder="MM/YYYY"
                    valueFormat={'MM/YYYY'}
                    label={'End Date'}
                    onChange={(value) => {
                      if (value) {
                        setData((prevData) => ({
                          ...prevData,
                          work_experience_one_end_date: moment(value).format('YYYY-MM'),
                        }))
                      } else {
                        setData((prevData) => ({
                          ...prevData,
                          work_experience_one_end_date: '',
                        }))
                      }
                    }}
                    error={errors.work_experience_one_end_date}
                  />
                </HStack>
              </HStack>
            </VStack>
          </VStack>
        )}
      </VStack>
      <HStack>
        <Divider variant={'dotted'}></Divider>
      </HStack>
      <HStack spacing={'12px'} justifyContent="flex-end">
        <Button
          label={'Cancel'}
          variant={'secondary'}
          onClick={() => {
            dispatch(updateShowAddQuickLeadModal(false))
            reset()
          }}
        ></Button>
        <Button
          label={'Create'}
          onClick={() => {
            setLoading(true)
            post(route('leads.quick-create'), {
              preserveState: true,
              preserveScroll: true,
              onFinish: () => {
                setLoading(false)
              },
            })
          }}
        ></Button>
      </HStack>
    </VStack>
  )
}

export default CreateQuickStudyLead
